<template>
  <div>
    <v-row noGutters>
      <BaseSidebar
        :items="[]"
        :initialMini="true"
      />
    </v-row>
    <VTableLocal
      :iconHeader="null"
      :items="alerts"
      isSearchable
      detectSearchInput
      :isSelectable="false"
      :headers="tableHeaders"
      :title="$t('alertsNotifications.pageName')"
      :showRowIcon="false"
      :verticalActionDots="true"
      :includeInactiveStats="true"
      :isFilterEnable="true"
      :multiple="true"
      :filterItems="getFilterItems"
      :disablePagination="true"
      showExpand
      customClass="alertNotification"
      @filter-type-changed="filterChanged"
      @onSearchInput="handleSearch"
    >
      <template #item.createdAt="{ item }">
        <p class="date">
          <span class="label">{{ $t('alertsNotifications.lastNotified') }}</span>: {{ item.lastNoticedAt }}
        </p>
      </template>
      <template #item.type="{ item }">
        <p>
          <span class="label">{{ $t(`alerts.labels.${item.type.toLowerCase()}`) }}</span>
        </p>
      </template>
      <template #item.status="{ item }">
        <VCheckbox
          :value="isNotificationAcknowledge(item)"
          color="#26384B"
          class="checkbox"
          @input="changeAlertStatus(item)"
        />
      </template>
      <template #item.acknowledgeBy="{ item }">
        <span
          v-if="item.acknowledgeBy"
          class="acknowledgeBy"
        >
          <v-icon
            small
            style="padding-bottom: 5px;"
          >
            done
          </v-icon>
          {{ item.acknowledgeBy }}
        </span>
      </template>
      <template #item.report="{ item }">
        <div class="pdf-report">
          <v-btn
            icon
            xSmall
            @click="downloadReport(item.report)"
          >
            <v-icon>
              mdi-link-variant
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template #expanded-item="props">
        <td :colspan="props.headers.length">
          <AlertDetails
            :alertId="props.item.id"
            :type="props.item.type"
          />
        </td>
      </template>
    </VTableLocal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VTableLocal from '@/components/shared/content-views/VTableLocal';
import AlertDetails from '@/views/alerts/AlertDetails.vue';
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';
import BaseSidebar from '@/components/shared/navigation/BaseSidebar.vue';

export default {
    components: {
        VTableLocal,
        AlertDetails,
        VCheckbox,
        BaseSidebar,
    },
    data() {
        return {
            loading: false,
            alerts: [],
            filterItems: ['analysis', 'inventory', 'unacknowledged', 'acknowledged'],
            queryParams: { page: 1, pergage: 10, search: '' },
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'unacknowledgedAlerts',
        ]),
        tableHeaders() {
            const headers = [
                {
                    text: this.$t('forms.labels.alertName'),
                    value: 'name',
                },
                {
                    text: this.$t('forms.labels.site'),
                    value: 'site',
                },
                {
                    text: this.$t('forms.labels.client'),
                    value: 'client',
                },
                {
                    text: this.$t('forms.labels.type'),
                    value: 'type',
                },
                {
                    text: this.$t('forms.labels.timestamps'),
                    value: 'createdAt',
                },
                {
                    text: this.$t('forms.labels.repport'),
                    value: 'report',
                },
                {
                    text: this.$t('forms.labels.acknowledge'),
                    value: 'status',
                },
                {
                    text: '',
                    value: 'acknowledgeBy',
                },
                {
                    text: '',
                    value: '',
                    sortable: false,
                },
                { text: 'Details', value: 'data-table-expand' },
            ];
            return headers;
        },
        getFilterItems() {
            return this.filterItems.map(item => ({
                key: item,
                name: this.$t(`forms.labels.${item}`),
            }));
        },
    },
    watch: {
        unacknowledgedAlerts: {
            handler() {
                this.loadData(true);
            },
            deep: true,
        },
    },
    async created() {
        await this.loadData();
    },
    async mounted() {
        window.onscroll = () => {
            if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight) {
                if (this.alerts.length < this.queryParams.totalElementCount) {
                    this.queryParams = {
                        ...this.queryParams,
                        page: this.queryParams.page + 1,
                    };
                    this.loadData();
                }
            }
        };
    },
    methods: {
        ...mapActions({
            reloadNotifications: 'getUnacknowledgedAlerts',
        }),
        async loadData(overwrite = false) {
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined(this.queryParams, true);
            const { data } = await this.$rq.getAllNotifications(cleanQueryParams);
            const alerts = data.alertsNotifications.map(currentAlert => ({
                id: currentAlert.id,
                name: currentAlert.alert.name,
                lastNoticedAt: this.$options.filters.formatDate(currentAlert.createdAt, 'L LT'),
                createdAt: this.$options.filters.formatDate(currentAlert.alert.createdAt, 'L LT'),
                type: currentAlert.alert.type,
                status: currentAlert.status,
                report: currentAlert.report,
                acknowledgeBy: currentAlert.acknowledgedDate && this.isNotificationAcknowledge(currentAlert)
                    ? `${currentAlert.acknowledgedBy.firstName} ${currentAlert.acknowledgedBy.lastName} -
                    ${this.$options.filters.formatDate(currentAlert.acknowledgedDate, 'L LT')}`
                    : undefined,
                client: currentAlert.client.name,
                site: currentAlert.site.name,
            }));
            this.queryParams = { ...this.queryParams, ...data.pagination };
            this.alerts = alerts.length && !overwrite ? [...this.alerts, ...alerts] : alerts;
        },
        filterChanged(payload) {
            this.queryParams = { filterby: payload, page: 1 };
            this.loadData(true);
        },
        async changeAlertStatus(alert) {
            const body = {
                status: this.isNotificationAcknowledge(alert) ? 'unacknowledged' : 'acknowledged',
            };
            await this.$rq.changeNotificationStatus(alert.id, body);
            await this.loadData(true);
            await this.reloadNotifications();
        },
        isNotificationAcknowledge(notification) {
            return notification?.status === 'Acknowledged' || notification?.status === 'Reconnu';
        },
        async downloadReport(report) {
            const { data } = await this.$rq.downloadFile(report.file.id);

            this.$utils.saveFileOnDisk(data, report.file.fileName);
        },
        handleSearch(search) {
            this.queryParams.search = search;
            this.loadData(true);
        },
    },
};
</script>
<style scoped lang="scss">
    .date {
        margin-bottom: 0px;
        .label {
            font-weight: bold;
        }
    }
    .unacknowledged {
        border-color: #26384b;
        color: #26384b;
        border: 1px solid;
        background-color: white !important;
    }
    .acknowledgeBy {
        color: gray;
        font-size: 13px !important;
    }
    .checkbox {
        display: flex;
        justify-content: center;
    }
    .pdf-report {
        display: flex;
        justify-content: center
    }
</style>
<style lang="scss">
    @media screen and (min-width: 1500px) {
        .text-start:has(.acknowledgeBy) {
            min-width: 350px;
        }
    }
</style>
